import React, { useState } from "react";
import { Link, RichText } from "prismic-reactjs";
import Collapse from "@material-ui/core/Collapse";
import linkResolver from "./../helpers/linkResolver.js";
import isValidLink from "../helpers/isValidLink";
import { get } from "lodash";

export default function RenderMoodsSection(slice) {
  const backgroundStyle = {
    background: slice.primary.background_color,
  };

  const ctaText = slice.primary.cta_text;
  const ctaLink = slice.primary.cta_link;
  const ctaAlignment = slice.primary.cta_alignment;

  function renderMoods(items) {
    function Mood(el, i) {
      const [open, setOpen] = useState(false);
      const ctaText = el.cta_text;
      const ctaLink = el.cta_link;

      const ctaText2 = el.cta_text_2;
      const ctaLink2 = el.cta_link_2;

      return (
        <div
          className={`mood-item animate ${el.coming_soon && "coming-soon"}`}
          style={{
            background: el.background_color,
            color: el.text_color,
            backgroundImage: `url(${get(el.background_image, "url")})`,
          }}
          key={"mood-item-" + i}
          onClick={() => setOpen(!open)}
        >
          <div className="toggle" onClick={() => setOpen(!open)}>
            <div className="toggle-text">{!open ? "more" : "less"}</div>
            <div className={`toggle-icon ${open && "open"}`}>v</div>
          </div>
          <div
            className="lifestyle-image"
            style={{ background: "url(" + el.image_2.url + ")" }}
          ></div>

          <div className="content">
            <div className="text-content">
              <div className="text-content-1">
                <RichText render={el.content} />
              </div>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <div className="text-content-2">
                  <RichText render={el.content2} />
                </div>

                {isValidLink(ctaLink, ctaText) && (
                  <div className={"buttons"}>
                    <a
                      href={Link.url(el.cta_link, linkResolver)}
                      className="button"
                      style={{
                        backgroundColor: "white",
                        color: el.background_color,
                      }}
                    >
                      {el.cta_text[0].text}
                    </a>
                  </div>
                )}

                {isValidLink(ctaLink2, ctaText2) && (
                  <div className={"buttons"}>
                    <a
                      href={Link.url(el.cta_link_2, linkResolver)}
                      className="button"
                      style={{
                        backgroundColor: "white",
                        color: el.background_color,
                      }}
                    >
                      {el.cta_text_2[0].text}
                    </a>
                  </div>
                )}
              </Collapse>
            </div>
            <div className="product-image">
              <img src={el.image_1.url} alt="Mood" />
            </div>
          </div>
        </div>
      );
    }

    return items.map((el, i) => Mood(el, i));
  }

  return (
    <section className="moods-section" style={backgroundStyle}>
      <div className="wrapper">
        {slice.primary.content && slice.primary.content[0].text && (
          <div className="standard-padding gray-headlines-and-copy">
            <RichText render={slice.primary.content} />
            {isValidLink(ctaLink, ctaText) && (
              <div
                className={`buttons ${
                  ctaAlignment === "center-align" && "center-align"
                } ${ctaAlignment === "right-align" && "right-align"}`}
              >
                <a href={Link.url(ctaLink, linkResolver)} className="button">
                  {ctaText[0].text}
                </a>
              </div>
            )}
          </div>
        )}
        <div className="moods-wrapper">{renderMoods(slice.items)}</div>
      </div>
    </section>
  );
}
